define("settings/components/downgrade-slide-users", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="tDG--slide" data-test-id="users-slide">
    <div class="o--modalHeader tDG--slideHeader">
      <p class="o--modalHeader__title">
        {{t "account.downgrade.team_members.title" count=@overageUsers}}
      </p>
      <p class="u--m__tb__xs">
        {{t "account.downgrade.team_members.subtitle" count=@targetTeamMemberCount}}
      </p>
    </div>
    <div class="o--modalBody tDG--scroll__body">
      <div class="u--row">
        <Downgrade::TeamMembers
          @overageUsers={{@overageUsers}}
          @removeTeamMember={{@removeTeamMember}}
          @restoreTeamMember={{@restoreTeamMember}}
          @teamMembers={{@teamMembers}}
          @teamMembersToRemove={{@teamMembersToRemove}}
        />
      </div>
    </div>
  </div>
  */
  {
    "id": "gEQvYjM8",
    "block": "[[[10,0],[14,0,\"tDG--slide\"],[14,\"data-test-id\",\"users-slide\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"o--modalHeader tDG--slideHeader\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"o--modalHeader__title\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"account.downgrade.team_members.title\"],[[\"count\"],[[30,1]]]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,2],[14,0,\"u--m__tb__xs\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"account.downgrade.team_members.subtitle\"],[[\"count\"],[[30,2]]]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"o--modalBody tDG--scroll__body\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"u--row\"],[12],[1,\"\\n      \"],[8,[39,1],null,[[\"@overageUsers\",\"@removeTeamMember\",\"@restoreTeamMember\",\"@teamMembers\",\"@teamMembersToRemove\"],[[30,1],[30,3],[30,4],[30,5],[30,6]]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@overageUsers\",\"@targetTeamMemberCount\",\"@removeTeamMember\",\"@restoreTeamMember\",\"@teamMembers\",\"@teamMembersToRemove\"],false,[\"t\",\"downgrade/team-members\"]]",
    "moduleName": "settings/components/downgrade-slide-users.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});